var colors = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#ffffff",
  blue: /*#__PURE__*/Object.assign("#3700FF", {
    100: "#F2F2FF",
    200: "#E3E5FF",
    300: "#C5CCFF",
    400: "#AAB3FF",
    900: "#5548FF",
    hover: "#3100DC"
  }),
  ink: /*#__PURE__*/Object.assign("#111215", {
    50: "#f4f4f5",
    100: "#FAFAFC",
    150: "#F0F0F5",
    200: "#E1E3E8",
    250: "#C8C8CC",
    300: "#C1C3CC",
    400: "#A1A7B3",
    600: "#767A85",
    900: "#42444E"
  }),
  darken: {
    50: "rgba(15, 17, 23, 0.05)",
    100: "rgba(15, 17, 23, 0.1)",
    150: "rgba(15, 17, 23, 0.15)"
  },
  red: "#D4001A",
  green: "#00A73E",
  orange: "#F9A14D",
  cyan: "#00d4ff",
  moss: "#0F5257",
  purple: "#6014B8",
  violet: "#AAA9DD",
  feedback: {}
};
colors.feedback = {
  error: colors.red,
  success: colors.green,
  warning: colors.orange,
  info: colors.cyan
};

export { colors };
//# sourceMappingURL=colors.esm.js.map
